/**
 * A refusal's words for the field it belongs to. The door's zod refusal arrives as its issues
 * in JSON (tRPC's BAD_REQUEST); the first issue's message is the one written for a person
 * (`replyToEmailField`'s). Anything else is shown as it came.
 */
export function fieldErrorOf(message: string): string {
  try {
    const issues: unknown = JSON.parse(message);
    if (Array.isArray(issues)) {
      const first = issues.find(
        (i): i is { message: string } =>
          typeof i === 'object' && i !== null && typeof i.message === 'string',
      );
      if (first) return first.message;
    }
  } catch {
    // Not JSON: a sentence already.
  }
  return message;
}

/** A server-authored issue for one exact control, including an indexed row. */
export function fieldErrorAt(
  message: string | undefined,
  path: readonly (string | number)[],
): string | undefined {
  if (!message) return undefined;
  try {
    const issues: unknown = JSON.parse(message);
    if (!Array.isArray(issues)) return undefined;
    const issue = issues.find(
      (i) =>
        i &&
        typeof i === 'object' &&
        typeof i.message === 'string' &&
        Array.isArray(i.path) &&
        i.path.length === path.length &&
        i.path.every((part: unknown, n: number) => part === path[n]),
    );
    return issue?.message;
  } catch {
    return undefined;
  }
}

/** Capture feedback only. Bounds, precision and Keep/Fill rules belong to the server. */
export function numberTextIssue(value: string, label: string): string | undefined {
  return value.trim() && !Number.isFinite(Number(value))
    ? `Enter a number for ${label}.`
    : undefined;
}
